import { render, staticRenderFns } from "./TradingAccountsTab.vue?vue&type=template&id=7437522f"
import script from "./TradingAccountsTab.vue?vue&type=script&lang=js"
export * from "./TradingAccountsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports